import styled from '@emotion/styled';
import { Modal } from '@innovamat/glimmer-components';
import { useTranslation } from 'react-i18next';
import { useEnvVariables } from '../../../../env-variables-manager';

type Props = {
  show: boolean;
  onCancel: () => void;
};

const Title = styled.p`
  max-width: 300px;
  margin-bottom: 16px;
`;

const StyledModal = styled(Modal)`
  gap: 0;
`;

export default function WebViewModal({ show, onCancel }: Props) {
  const { t } = useTranslation();
  const { WEBAPP } = useEnvVariables();
  const url = `${WEBAPP}${window.location.search}`;

  return (
    <StyledModal
      isOpen={show}
      buttons={[
        {
          children: t('Login.webviewModal.link', 'Continuar'),
          onClick: () => {
            window.location.href = url;
          },
        },
        {
          children: t('Login.webviewModal.cancel', 'Cancelar'),
          variant: 'tertiary',
          onClick: () => {
            onCancel();
          },
        },
      ]}
    >
      <>
        <Title>
          {t(
            'Login.webviewModal',
            'Vas a ser redirigido a app-student, haz click en el enlace para continuar.'
          )}
        </Title>
      </>
    </StyledModal>
  );
}
